var _path, _path2, _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallConfetti1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 190,
    height: 260,
    viewBox: "0 0 190 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.6443 85.853C80.3281 86.7081 78.2943 88.2573 76.2319 90.5197C76.7504 87.6904 76.6307 85.2621 75.7522 82.9738C74.8247 80.5579 73.0833 78.3881 70.5603 76.0996C74.0619 76.7688 76.8972 76.6942 79.3779 75.7331C81.3727 74.9602 83.068 73.6409 84.6661 71.8107C84.2121 74.2852 84.317 76.4542 85.0919 78.4976C86.0146 80.9306 87.8494 83.0764 90.5611 85.3142C87.5361 84.8636 84.9872 84.9882 82.6443 85.853Z",
    stroke: "#007C6D",
    strokeWidth: 1.80952,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6684 173.176C38.7951 173.867 37.166 175.191 35.4599 177.192C36.0199 174.769 35.9952 172.773 35.282 170.916C34.5396 168.982 33.0706 167.253 30.8769 165.362C33.8274 166.026 36.1235 166.032 38.0935 165.268C39.7639 164.621 41.1524 163.439 42.4904 161.741C41.9613 163.918 41.9669 165.746 42.6105 167.443C43.346 169.383 44.8915 171.084 47.2498 172.926C44.6601 172.442 42.5652 172.475 40.6684 173.176Z",
    stroke: "#007C6D",
    strokeWidth: 0.904762,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 189.229,
    y: 64.9979,
    width: 5.59422,
    height: 5.59422,
    transform: "rotate(167.283 189.229 64.9979)",
    stroke: "#007C6D",
    strokeWidth: 0.904762
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 144.307,
    y: 199.141,
    width: 9.84196,
    height: 9.84196,
    transform: "rotate(167.283 144.307 199.141)",
    stroke: "#007C6D",
    strokeWidth: 0.904762
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7.22931,
    y: 5.99786,
    width: 5.59422,
    height: 5.59422,
    transform: "rotate(167.283 7.22931 5.99786)",
    stroke: "#007C6D",
    strokeWidth: 0.904762
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 84.2293,
    y: 257.998,
    width: 5.59422,
    height: 5.59422,
    transform: "rotate(167.283 84.2293 257.998)",
    stroke: "#007C6D",
    strokeWidth: 0.904762
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallConfetti1);
export default __webpack_public_path__ + "static/media/small_confetti1.1d54a9e0a7ea7e070644d84407a5b85a.svg";
export { ForwardRef as ReactComponent };